import { createFileRoute } from "@tanstack/react-router";
import AdminClientErrors from "@/pages/admin/AdminClientErrors";

export const Route = createFileRoute("/admin/errores")({ component: AdminClientErrors });
